export default "__VITE_ASSET__DRWOQ_t9__"